export default class OptionsValidator {
    constructor(options) {
        this._options = options;
    }

    isValid(value) {
        return this._options.some((option) => option.value == value || option == value || value == "");
    }

    errorMessage() {
        return "Opción inválida";
    }
}
